<div
  class="text-3xl text-black font-semibold h-screen w-screen flex items-center justify-center"
>
  Welcome to Finance Admin
</div>
